import OrderVacation from "../vue/OrderVacation/OrderVacation.vue";
import Vue from "vue";

export default {
  init() {
    window.eventBus = new Vue();


    new Vue({
      el: "#order-vacation",
      components: { OrderVacation },
      template: "<OrderVacation />"
    });
  }
};
